import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import FaqHero from '../components/faq/FaqHero';
import FaqList from '../components/faq/FaqList';
import styles from './FaqPage.module.css';

// Public FAQ page. Reuses the marketing nav/footer and owns its own scroll container
// (global `body { overflow: hidden }` for the app shell).
export default function FaqPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <FaqHero />
        <FaqList />
      </main>
      <LandingFooter />
    </div>
  );
}
